module.exports = __webpack_public_path__ + "static/img/2-2.02e8082.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2-2.jpg
// module id = oPZL
// module chunks = 0